// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1_0zM","rootMobile":"styles_rootMobile__39rR9"};